// Países soportados: LATAM + Caribe + USA + Canadá + España + Brasil + Portugal
// dial sin '+'. min/max = longitud del número nacional.
export const COUNTRIES = [
  { iso: "PE", name: "Perú", dial: "51", flag: "🇵🇪", min: 9, max: 9 },
  { iso: "AR", name: "Argentina", dial: "54", flag: "🇦🇷", min: 10, max: 11 },
  { iso: "BS", name: "Bahamas", dial: "1", flag: "🇧🇸", min: 10, max: 10 },
  { iso: "BB", name: "Barbados", dial: "1", flag: "🇧🇧", min: 10, max: 10 },
  { iso: "BZ", name: "Belice", dial: "501", flag: "🇧🇿", min: 7, max: 7 },
  { iso: "BO", name: "Bolivia", dial: "591", flag: "🇧🇴", min: 8, max: 8 },
  { iso: "BR", name: "Brasil", dial: "55", flag: "🇧🇷", min: 10, max: 11 },
  { iso: "CA", name: "Canadá", dial: "1", flag: "🇨🇦", min: 10, max: 10 },
  { iso: "CL", name: "Chile", dial: "56", flag: "🇨🇱", min: 9, max: 9 },
  { iso: "CO", name: "Colombia", dial: "57", flag: "🇨🇴", min: 10, max: 10 },
  { iso: "CR", name: "Costa Rica", dial: "506", flag: "🇨🇷", min: 8, max: 8 },
  { iso: "CU", name: "Cuba", dial: "53", flag: "🇨🇺", min: 8, max: 8 },
  { iso: "EC", name: "Ecuador", dial: "593", flag: "🇪🇨", min: 9, max: 9 },
  { iso: "SV", name: "El Salvador", dial: "503", flag: "🇸🇻", min: 8, max: 8 },
  { iso: "ES", name: "España", dial: "34", flag: "🇪🇸", min: 9, max: 9 },
  { iso: "US", name: "Estados Unidos", dial: "1", flag: "🇺🇸", min: 10, max: 10 },
  { iso: "GT", name: "Guatemala", dial: "502", flag: "🇬🇹", min: 8, max: 8 },
  { iso: "GY", name: "Guyana", dial: "592", flag: "🇬🇾", min: 7, max: 7 },
  { iso: "HT", name: "Haití", dial: "509", flag: "🇭🇹", min: 8, max: 8 },
  { iso: "HN", name: "Honduras", dial: "504", flag: "🇭🇳", min: 8, max: 8 },
  { iso: "JM", name: "Jamaica", dial: "1", flag: "🇯🇲", min: 10, max: 10 },
  { iso: "MX", name: "México", dial: "52", flag: "🇲🇽", min: 10, max: 10 },
  { iso: "NI", name: "Nicaragua", dial: "505", flag: "🇳🇮", min: 8, max: 8 },
  { iso: "PA", name: "Panamá", dial: "507", flag: "🇵🇦", min: 8, max: 8 },
  { iso: "PY", name: "Paraguay", dial: "595", flag: "🇵🇾", min: 9, max: 9 },
  { iso: "PT", name: "Portugal", dial: "351", flag: "🇵🇹", min: 9, max: 9 },
  { iso: "FR", name: "Francia", dial: "33", flag: "🇫🇷", min: 9, max: 9 },
  { iso: "IN", name: "India", dial: "91", flag: "🇮🇳", min: 10, max: 10 },
  { iso: "DE", name: "Alemania", dial: "49", flag: "🇩🇪", min: 10, max: 11 },
  { iso: "PR", name: "Puerto Rico", dial: "1", flag: "🇵🇷", min: 10, max: 10 },
  { iso: "DO", name: "República Dominicana", dial: "1", flag: "🇩🇴", min: 10, max: 10 },
  { iso: "SR", name: "Surinam", dial: "597", flag: "🇸🇷", min: 7, max: 7 },
  { iso: "TT", name: "Trinidad y Tobago", dial: "1", flag: "🇹🇹", min: 10, max: 10 },
  { iso: "UY", name: "Uruguay", dial: "598", flag: "🇺🇾", min: 8, max: 9 },
  { iso: "VE", name: "Venezuela", dial: "58", flag: "🇻🇪", min: 10, max: 10 },
];

export const getCountry = (iso) => COUNTRIES.find((c) => c.iso === iso) || COUNTRIES[0];

// Valida el número nacional según el país. Devuelve national (solo dígitos) y e164.
export function validateIntlPhone(iso, raw) {
  const c = getCountry(iso);
  if (!raw) return { valid: false, message: "⚠️ Ingresa tu número de teléfono" };
  let digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith(c.dial) && digits.length > c.max) {
    digits = digits.slice(c.dial.length);
  }
  if (digits.length < c.min || digits.length > c.max) {
    const range = c.min === c.max ? `${c.min}` : `${c.min}-${c.max}`;
    return { valid: false, message: `⚠️ El número de ${c.name} debe tener ${range} dígitos` };
  }
  if (c.iso === "PE" && !digits.startsWith("9")) {
    return { valid: false, message: "⚠️ El celular peruano debe empezar con 9 (Ej: 987654321)" };
  }
  return { valid: true, national: digits, e164: `+${c.dial}${digits}` };
}

// Convierte un teléfono guardado (E.164 o legacy nacional) a {iso, national}
export function splitE164(stored, fallbackIso = "PE") {
  if (!stored) return { iso: fallbackIso, national: "" };
  const s = String(stored).trim();
  if (!s.startsWith("+")) return { iso: fallbackIso, national: s.replace(/\D/g, "") };
  const digits = s.slice(1).replace(/\D/g, "");
  const sorted = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  const fb = getCountry(fallbackIso);
  if (digits.startsWith(fb.dial)) {
    const nat = digits.slice(fb.dial.length);
    if (nat.length >= fb.min && nat.length <= fb.max) return { iso: fb.iso, national: nat };
  }
  for (const c of sorted) {
    if (digits.startsWith(c.dial)) {
      const nat = digits.slice(c.dial.length);
      if (nat.length >= c.min && nat.length <= c.max) return { iso: c.iso, national: nat };
    }
  }
  return { iso: fallbackIso, national: digits };
}
